import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/native';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.css';
import { View, ScrollView, Text, TextInput, Pressable } from 'react-native';
import webStyled from 'styled-components';

import {
  elRed,
  elGray,
  elLightGray
} from '../styles/colors';

export const SubNavContainer = styled(View)`
  display: flex;
  flex-direction: row;
  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
  border-bottom-width: 1px;
  border-bottom-color: black;
`;

export const SubNavContainerFullWidth = styled(View)`
  display: flex;
  flex-direction: row;
  flex: 0.5;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
  border-bottom-width: 1px;
  border-bottom-color: black;
`;

export const ContentContainer = styled(View)`
  padding: 40px;
`;

export const TableContainer = styled(View)`
  background-color: ${elGray};
  border: 2px solid black;
  border-radius: 5px;
  margin-top: -20px;
`;

export const ModalTableContainer = styled(View)`
  height: 60vh;
`;

export const TitleContainer = styled(View)`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const PageTitle = styled(Text)`
  font-weight: bold;
  color: ${elRed};
  font-size: 24px;
`;

export const ContainerTitle = styled(Text)`
  font-weight: bold;
  color: ${elRed};
  font-size: 20px;
`;

export const ErrorMessage = styled(View)`
  color: red;
  border: 2px solid red;
  padding: 4px;
  margin-bottom: 6px;
`;

export const MainContainer = styled(View)`
  @media (max-width: 600px) {
    margin: 5px;
  }
`;

export const TopContainer = styled(View)`
  display: flex;
  margin-bottom: 80px;

  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const MiddleContainer = styled(View)`
  display: flex;
  margin-bottom: 80px;

  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const BottomContainer = styled(View)`
  display: flex;
  margin-bottom: 80px;

  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const ColumnContainer = styled(View)`
  display: flex !important;
  flex: 1;
  flex-direction: ${props => props.isMobile ? 'column' : 'row'};
  margin-left: 1%;
  margin-right: 1%;
  margin-top: 10px;
`;

export const LeftContainer = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  margin-right: ${props => props.isMobile ? '0px' : '20px'};
  background-color: ${elGray};
  border: 1px solid black;
  border-radius: 5px;
  min-height: ${props => props.isMobile ? '100vh' : '80vh'};
  flex-grow: 1;
  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const RightContainer = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  background-color: ${elGray}
  border: 1px solid black;
  border-radius: 5px;
  min-height: ${props => props.isMobile && props.screenWidth ? (2 * props.screenWidth) + 'vh' : '80vh'};
  flex-grow: 1;
  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const Label = styled(Text)`
  display: block;
  color: ${elRed};
  font-weight: 500;
  margin-top: 12px;
`;

export const Button = webStyled.button`
  background-color: ${elRed};
  color: white;
  border: 0px;
  border-radius: 4px;
  height: 37px;
  font-size: 0.9rem;
  font-weight: 500;
  width: 100%;
  margin-top: 16px;
`;

export const CancelButton = webStyled.div`
  background-color: white;
  color: ${elRed};
  margin-top: 16px;
  border: 1px solid ${elRed};
`;

export const ActionButton = styled(Link)`
  color: black;
  background-color: #eeeeee;
  padding: 6px;
  margin: 6px;
  text-decoration: none;
  border-radius: 6px;
  white-space: nowrap;
`;

export const ActionIcon = styled(FontAwesomeIcon)`
  margin-right: 6px;
  font-weight: 500;
  color: ${elRed};
`;

const inputStyles = `
  display: block;
  width: 100%;
  padding: 0px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-top: 10px;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 1rem;

  .gray-input & {
    background-color: #EFEFEF;
    border: none;
  }
`;

const FieldError = styled(Text)`
  color: red;
`;

export const Input = props => {
  const [field, meta] = useField(props);

  return (
    <>
      <StyledInput
        {...field}
        {...props}
      />
      {meta.touched && meta.error && (
        <FieldError>{meta.error}</FieldError>
      )}
    </>
  );
};

const StyledInput = webStyled.input`
  ${inputStyles}
`;

const standardizedPhone = value => {
  if (value) {
    return '+1' + value.replace(/[-()/\s+/]/g, '');
  }

  return null;
};

// export const PhoneInput = props => {
//   const [field, meta] = useField(props);
//   const {setFieldValue, label} = props;

//   return (
//     <>
//       {/* <StyledPhoneInput
//         country="US"
//         {...field}
//         {...props}
//         onChange={value => setFieldValue(field.name, standardizedPhone(value))}
//       /> */}
//       <MuiTelInput
//         label={label}
//         onChange={value => setFieldValue(field.name, value)}
//         defaultCountry="US"
//         fullWidth
//         disableDropdown={true}
//         size='small'
//         preferredCountries={[]}
//         value={field.value}
//       />
//       {meta.touched && meta.error && (
//         <FieldError>{meta.error}</FieldError>
//       )}
//     </>
//   );
// };

export const Select = props => {
  const [field, meta] = useField(props);

  return (
    <>
      <StyledSelect
        {...field}
        {...props}
      />
      {meta.touched && meta.error && (
        <FieldError>{meta.error}</FieldError>
      )}
    </>
  );
};

export const CardContainer = styled(ScrollView)`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

export const ThumbCardContainer = styled(View)`
  width: fit-content;
  flex-direction: column;
  padding: 10px;
  overflow: scroll;
`;

export const Card = styled(View)`
  background-color: #fff;
  border: 1px solid black;
  border-radius: 5px;
  padding: 10px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: 10px;
`;

export const DocCard = styled(View)`
  background-color: #fff;
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: -10px;
`;

export const StockCard = styled(View)`
  background-color: #fff;
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
  width: 100px
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: -10px;
`;

export const AssetCardUpperContainer = styled(View)`
  display: flex;
  flex-direction: row;
`;

export const AssetCardImage = styled(View)`
  flex: 0.25;
  background-color: ${elGray};
  height: fit-content;
  min-height: 80px;
  justify-content: center;
`;

export const AssetCardDetails = styled(View)`
  flex: 0.75;
  padding-vertical: 4px;
  padding-horizontal: 10px;
`;

export const AssetCardSaleInfo = styled(View)`
  flex-direction: row;
  justify-content: flex-start;

`;

export const CardButtonGroup = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CardBoldText = styled(Text)`
  font-weight: bold;
  margin-bottom: 10px;
`;

export const LinkContainer = styled(View)`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-start;
`;

export const LinkSpace = styled(View)`
  width: 5%;
`;

export const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;

  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
`;

export const TableNavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;
  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elGray};
  padding: 15px;
  padding-left: 15px;
`;

export const BoldLinkText = styled(Text)`
font-weight: bold;
`;

export const HR = styled(View)`
  border: 2px solid ${elGray};
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const ButtonContainer = styled(View)`

`;

export const TabButtonContainer = styled(View)`
  flex-direction: row;
  align-items: flex-start;
  margin-top: 20px;
  margin-bottom: 17px;
`

export const TabButton = styled(Pressable)`
  border: solid black 2px;
  width: 20%;
  border-radius: 3px;
  padding: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${props => props.active ? elRed : elLightGray};
`

export const AssetTabButton = styled(Pressable)`
  border: solid black 2px;
  width: 14%;
  border-radius: 3px;
  padding: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${props => props.active ? elRed : elLightGray};
`

export const InactiveResourceTabButton = styled(Pressable)`
  border: solid black 2px;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 3px;
  padding: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${props => props.active ? elRed : elLightGray};
`

export const TabText = styled(Text)`
  font-weight: 900:
  font-size: 20px;
  color: ${props => props.active ? 'white' : 'black'};
`

export const BankAccountsContainer = styled(View)`

`;
